import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  dialogPaper: {
    borderRadius: 20,

    margin: 0,
    width: '100%',
    '& .MuiDialogActions-spacing > :not(:first-child)': {
      marginLeft: 0,
      marginTop: '1rem',
    },
  },
  dialogContent: {
    padding: '16px 16px 10px',
  },
  dialog: {
    width: '100%',
  },
  dialogTitle: {
    color: theme.palette.black.main,
    fontSize: 16,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
}));

export default useStyles;
